export const laundryProfile = {
  name: 'مغسلة اللمسة النظيفة',
  city: 'الرياض',
  logo: 'https://readdy.ai/api/search-image?query=Minimal%20flat%20vector%20logo%20mark%20of%20a%20blue%20water%20droplet%20combined%20with%20a%20white%20folded%20shirt%20icon%2C%20clean%20simple%20design%2C%20soft%20blue%20gradient%20background%2C%20centered%2C%20no%20text&width=120&height=120&seq=laundry-avatar-01&orientation=squarish',
};

export const dashboardKpis = [
  {
    id: 'new',
    label: 'طلبات جديدة',
    value: '5',
    icon: 'ri-inbox-archive-line',
    tone: 'info',
    highlight: true,
    note: 'بانتظار القبول أو الرفض',
    trend: { pct: '+2 عن أمس', up: true },
  },
  {
    id: 'progress',
    label: 'طلبات جارية',
    value: '12',
    icon: 'ri-loader-4-line',
    tone: 'primary',
    highlight: false,
    note: 'قيد التنفيذ الآن',
    trend: { pct: '+4 عن أمس', up: true },
  },
  {
    id: 'done',
    label: 'مكتملة اليوم',
    value: '23',
    icon: 'ri-checkbox-circle-line',
    tone: 'success',
    highlight: false,
    note: 'أكّد العميل استلامها',
    trend: { pct: '+7 عن أمس', up: true },
  },
  {
    id: 'revenue',
    label: 'إيرادات اليوم',
    value: '1,250 ر.س',
    icon: 'ri-wallet-3-line',
    tone: 'accent',
    highlight: false,
    note: '+18% عن أمس',
    trend: { pct: '18%+', up: true },
  },
];

export const dashboardInsights = {
  orderStatus: [
    { label: 'مكتملة', count: 23, color: 'bg-success-500' },
    { label: 'جارية', count: 12, color: 'bg-secondary-400' },
    { label: 'جديدة', count: 5, color: 'bg-accent-400' },
    { label: 'ملغاة', count: 3, color: 'bg-background-300' },
  ],
  drivers: { active: 8, busy: 11, offline: 3 },
  topService: [
    { name: 'غسيل عادي', orders: 18, pct: 78 },
    { name: 'كوي', orders: 11, pct: 48 },
    { name: 'تنظيف جاف', orders: 7, pct: 30 },
    { name: 'غسيل مفارش', orders: 4, pct: 17 },
  ],
};

export const dashboardAlerts = [
  {
    id: 'alert-1',
    orderNo: '#98745',
    title: 'طلب #98745 — يحتاج تعيين مندوب يدوي',
    note: 'العميل اختار الانتظار عند عدم توفر مندوب تسليم وانتهت المدة المحددة',
    waitingFor: 'منذ 45 دقيقة',
  },
  {
    id: 'alert-2',
    orderNo: '#98731',
    title: 'طلب #98731 — يحتاج تعيين مندوب يدوي',
    note: 'العميل اختار الانتظار عند عدم توفر مندوب تسليم وانتهت المدة المحددة',
    waitingFor: 'منذ 20 دقيقة',
  },
];

export const dashboardNewOrders = [
  {
    id: 'ORD-98756',
    orderNo: '#98756',
    customer: 'نورة العتيبي',
    customerPhone: '0551234567',
    items: 'قميص × 3، بنطلون × 2',
    itemsCount: 5,
    priority: 'urgent',
    amount: '185 ر.س',
    time: 'قبل 4 دقائق',
    source: 'مباشر',
  },
  {
    id: 'ORD-98755',
    orderNo: '#98755',
    customer: 'عبدالله الشمري',
    customerPhone: '0567891234',
    items: 'ثوب × 4، عباية × 1',
    itemsCount: 5,
    priority: 'normal',
    amount: '140 ر.س',
    time: 'قبل 12 دقيقة',
    source: 'باقة',
  },
  {
    id: 'ORD-98754',
    orderNo: '#98754',
    customer: 'سارة القحطاني',
    customerPhone: '0509876543',
    items: 'فستان × 1، جاكيت × 2',
    itemsCount: 3,
    priority: 'urgent',
    amount: '210 ر.س',
    time: 'قبل 26 دقيقة',
    source: 'مباشر',
  },
  {
    id: 'ORD-98752',
    orderNo: '#98752',
    customer: 'محمد الدوسري',
    customerPhone: '0533456789',
    items: 'مفرش × 2، بدلة × 1',
    itemsCount: 3,
    priority: 'normal',
    amount: '165 ر.س',
    time: 'قبل 38 دقيقة',
    source: 'مباشر',
  },
  {
    id: 'ORD-98750',
    orderNo: '#98750',
    customer: 'هند المطيري',
    customerPhone: '0576543210',
    items: 'قميص × 6',
    itemsCount: 6,
    priority: 'urgent',
    amount: '150 ر.س',
    time: 'قبل 52 دقيقة',
    source: 'باقة',
  },
];

export const dashboardNavCounts = {
  newOrders: 5,
  alerts: 2,
  notifications: 7,
};